import { Box, Flex, Image } from '@mantine/core'
import LOGO from '../../images/MTLLOGO.svg'
import React from 'react'
import { Link } from 'react-router-dom'

const ClientHeader = () => {
    return (
        <Flex p='xl' pos={'absolute'} top={0} left={0}>
            <Box to='/' component={Link} maw='90px'>
                <Image w='100%' src={LOGO} />
            </Box>
        </Flex>
    )
}

export default ClientHeader
